import { SxProps } from "@mui/material";

export const sxMeuCadastroTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left"
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxLabelDisabled: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxInputEmail: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '400px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset'
  }
}

export const sxInputCep: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px'
}

export const sxInputPhone: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '200px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}

export const sxBoxMeuCadastro: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '25px'
}

export const sxError: SxProps = {
  color: '#D84141',
  fontSize: '12px'
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px'
}

export const sxTextButton: SxProps = {
  border: "none",
  background: "transparent",
  color: "var(--Primary-01-Medium, #00995D)",
  textAlign: "center",
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  "&:hover": { background: 'unset' },
  '@media (max-width: 768px)': {
    height: '40px'
  }
}

export const sxCircularLoadingProgress: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  marginTop: '100px'
}